import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SmallPopover} from 'icsoc-antd-ex';
import {Popconfirm, message} from 'antd';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import IconFont from 'Components/common/iconFont';
import exportTasksActions from 'Actions/systemSetting/exportTasks';
import sort from 'Utils/sort';

// const {Text} = Typography;
const columns = (pageStatus, handleAction,login) => [
  {
    title: '序号',
    key: 'key',
    dataIndex: 'key',
    width: 60,
    fixed: 'left',
    render: (text, record, index) => {
      const {pageNum, pageSize} = pageStatus;

      return sort({pageNum, pageSize, index});
    },
  },
  {
    title: '导出任务名称',
    dataIndex: 'taskName',
    key: 'taskName',
    // width: 200,
    render: text => text || '--',
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    key: 'status',
    width: 150,
    render: (text, record) => {
      return (
        <div
          style={
            record.status === 2
              ? {color: '#F63C3C'}
              : record.status === 1
                ? {color: '#34CB82'}
                : record.status === 0
                  ? {color: '#40AEFC '}
                  : {color: '#53626F'}
          }>
          {[
            record.status === 0 ? '进行中' : null,
            record.status === 1 ? '已完成' : null,
            record.status === 2 ? '失败' : null,
            record.status === 3 ? '已停止' : null,
          ]}
        </div>
      );
    },
  },
  {
    title: '文件大小',
    dataIndex: 'fileSize',
    key: 'fileSize',
    width: 120,
    render: text => (text !== null && text ? `${text}M` : '--'),
  },
  {
    title: '提交时间',
    dataIndex: 'commitDate',
    key: 'commitDate',
    width: 200,
    render: text => text || '--',
  },
  {
    title: '操作人',
    dataIndex: 'commitUser',
    key: 'commitUser',
    width: 120,
    render: text => text || '--',
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: 80,
    fixed: 'right',
    render: (text, record) => {
      return (
        <div className="operate">
          <SmallPopover
            type="white"
            content={[
              record.status === 0 ? '取消' : null,
              record.status === 1 ? '下载' : null,
              record.status === 2 ? '重新开始' : null,
              record.status === 3 ? '重新开始' : null,
            ]}
            className="tooltip">
            {record.status === 1 && login.permissionsList.includes('systemSettingExportTasks.download') ? (
              <IconFont
                style={{marginRight: 10}}
                type="icon-robotdownload"
                onClick={() => handleAction('download', record.urls)}
              />
            ) : null}
            {record.status === 0 && login.permissionsList.includes('systemSettingExportTasks.cancel') ? (
              <IconFont
                style={{marginRight: 10}}
                type="icon-robotclose-circle"
                onClick={() => handleAction('stop', record.id)}
              />
            ) : null}
            {(record.status === 2 || record.status === 3) && login.permissionsList.includes('systemSettingExportTasks.startOrStop') ? (
              <IconFont
                style={{marginRight: 10}}
                type="icon-robotreload"
                onClick={() => handleAction('reload', record)}
              />
            ) : null}
          </SmallPopover>
          {record.status !== 0 && login.permissionsList.includes('systemSettingExportTasks.delete') ? (
            <SmallPopover type="white" content="删除" className="tooltip">
              <Popconfirm
                placement="leftBottom"
                title="确认删除该任务吗？"
                onConfirm={() => {
                  handleAction('delete', record.id);
                }}>
                <IconFont type="icon-robottrash" />
              </Popconfirm>
            </SmallPopover>
          ) : null}
        </div>
      );
    },
  },
];

class TableList extends UnionTableList {
  handleAction = (type, id) => {
    this[type](id);
  };

  // 删除
  delete = (id = '') => {
    const {
      actions,
      getTableList,
      pageStatus: {pageNum, pageSize} = {},
    } = this.props;
    actions
      .delet(id)
      .then(res => {
        if (res.payload.code === 200) {
          message.success('任务删除成功！');
        }
      })
      .finally(() => {
        getTableList({
          pageNum,
          pageSize,
        });
      });
  };

  // 取消
  stop = (id = '') => {
    const {
      getTableList,
      actions,
      pageStatus: {pageNum, pageSize} = {},
    } = this.props;
    actions
      .stop(id)
      .then(res => {
        if (res.payload.code === 200) {
          message.success('任务取消成功！');
        }
      })
      .finally(() => {
        getTableList({
          pageNum,
          pageSize,
        });
      });
  };

  // 下载
  download = (urls = {}) => {
    const {setDownloadModalVisible, actions} = this.props;
    setDownloadModalVisible();
    actions.downloadSet(urls);
  };

  // 重试
  reload = ({id = '', taskName = ''}) => {
    const {setReloadModalVisible, actions} = this.props;
    setReloadModalVisible();
    actions.reloadSet({id, taskName});
  };

  render() {
    const {
      tableListData: {data = [], total = 0} = {},
      loading,
      pageStatus,
      pageStatus: {pageNum, pageSize},
      login
    } = this.props;

    return (
      <React.Fragment>
        <CommonTable
          style={{marginTop: 20}}
          columns={columns(pageStatus, this.handleAction,login)}
          dataSource={[...data]}
          rowKey="id"
          loading={loading}
          extraHeight={20}
          scroll={{x: 900}}
          onChange={this.handleTableChange}
          pagination={{
            current: pageNum,
            total: total && parseInt(total, 10),
            pageSize,
            showTotal: () => `共 ${total} 条`,
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({systemSettingExportTasks,login}) => ({
  tableListData: systemSettingExportTasks.tableListData,
  pageStatus: systemSettingExportTasks.pageStatus,
  aiAppOptions: systemSettingExportTasks.aiAppOptions,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(exportTasksActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
